export const MAP_VIEWPORT_SCOPES = {
  FARM_MAP: "farm-map",
  RUMO_PISTA: "rumo-pista-ab",
  LANDPLOT: "landplot",
  TRACK_HEADING_MODAL: "track-heading-modal",
  SERVICE_ORDER_LOCATION: "service-order-location",
  SERVICE_ORDER_MANUAL_APPLICATION: "service-order-manual-application",
  DASHBOARD: "dashboard",
  FARM_RAIN: "farm-rain-history",
};

export function mapViewportStorageKey(scope, farmId) {
  return `map-viewport-${scope}-${farmId}`;
}

export function mapLayoutStorageKey(scope, farmId) {
  return `map-layout-${scope}-${farmId}`;
}

function normalizeMapLayout(layout) {
  if (!layout) return null;
  const listWidth = Number(layout.listWidth);
  const mapHeight = Number(layout.mapHeight);
  if (!Number.isFinite(listWidth) && !Number.isFinite(mapHeight)) {
    return null;
  }
  return {
    listWidth: Number.isFinite(listWidth) ? listWidth : null,
    mapHeight: Number.isFinite(mapHeight) ? mapHeight : null,
  };
}

export function readLocalMapLayout(scope, farmId) {
  if (!scope || !farmId) return null;
  try {
    const raw = localStorage.getItem(mapLayoutStorageKey(scope, farmId));
    if (!raw) return null;
    return normalizeMapLayout(JSON.parse(raw));
  } catch (error) {
    return null;
  }
}

export function writeLocalMapLayout(scope, farmId, layout) {
  if (!scope || !farmId || !layout) return;
  const normalized = normalizeMapLayout(layout);
  if (!normalized) return;
  localStorage.setItem(
    mapLayoutStorageKey(scope, farmId),
    JSON.stringify(normalized)
  );
}

export function normalizeCenter(center) {
  if (!center) return null;
  const lat = center.lat != null ? center.lat : center.ltd;
  const lng = center.lng;
  if (lat == null || lng == null) return null;
  return { lat: Number(lat), lng: Number(lng) };
}

export function normalizeViewport(viewport) {
  if (!viewport) return null;
  const lat = viewport.lat;
  const lng = viewport.lng;
  const zoom = viewport.zoom;
  if (lat == null || lng == null || zoom == null) return null;
  return {
    lat: Number(lat),
    lng: Number(lng),
    zoom: Number(zoom),
  };
}

export function readLocalMapViewport(scope, farmId) {
  if (!scope || !farmId) return null;
  try {
    const raw = localStorage.getItem(mapViewportStorageKey(scope, farmId));
    if (!raw) return null;
    return normalizeViewport(JSON.parse(raw));
  } catch (error) {
    return null;
  }
}

export function writeLocalMapViewport(scope, farmId, viewport) {
  if (!scope || !farmId || !viewport) return;
  localStorage.setItem(
    mapViewportStorageKey(scope, farmId),
    JSON.stringify(normalizeViewport(viewport))
  );
}

export function readViewportFromGoogleMap(map) {
  if (!map || !map.getCenter) return null;
  const center = map.getCenter();
  return normalizeViewport({
    lat: center.lat(),
    lng: center.lng(),
    zoom: map.getZoom(),
  });
}

export function applyViewportToGoogleMap(map, viewport) {
  const normalized = normalizeViewport(viewport);
  if (!map || !normalized) return;
  map.panTo({ lat: normalized.lat, lng: normalized.lng });
  map.setZoom(normalized.zoom);
}

export function resolveMapViewport({
  apiViewport,
  localViewport,
  fallbackCenter,
  fallbackZoom = 16,
  preferApi = false,
}) {
  const api = normalizeViewport(apiViewport);
  const local = normalizeViewport(localViewport);

  if (preferApi) {
    if (api) return api;
    if (local) return local;
  } else {
    if (local) return local;
    if (api) return api;
  }

  const center = normalizeCenter(fallbackCenter);
  if (center) {
    return { ...center, zoom: fallbackZoom };
  }

  return { lat: -15.78, lng: -47.93, zoom: fallbackZoom };
}
